import { FeatureFlags } from './config'
import React, { useState } from 'react'

const FeatureFlagsContext = React.createContext()

export const FeatureFlagsContextProvider = ({children}) => {
  const [featureFlags, setFeatureFlags] = useState(FeatureFlags)

  const setFlag = (name, value) => {
    const _flags = structuredClone(featureFlags) 
    _flags[name] = value
    setFeatureFlags(_flags)
  }

  return (
    <FeatureFlagsContext.Provider value={{featureFlags, setFlag}}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};


export default FeatureFlagsContext